import { Database, KeyRound, Network, ShieldCheck, Smartphone } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { appConfig, hasSupabaseConfig } from "../lib/config";

function Setting({
  icon: Icon,
  title,
  value,
  note,
}: {
  icon: typeof Database;
  title: string;
  value: string;
  note: string;
}) {
  return (
    <article className="setting-card">
      <Icon size={20} />
      <div>
        <span>{title}</span>
        <strong>{value}</strong>
        <p>{note}</p>
      </div>
    </article>
  );
}

export function SettingsPage() {
  return (
    <>
      <PageHeader
        eyebrow="Operação privada"
        title="Configurações"
        description="Estado da infraestrutura e regras que não podem ficar implícitas."
      />
      <div className="settings-grid">
        <Setting
          icon={Database}
          title="Data source"
          value={
            appConfig.demoMode
              ? "Fixtures locais explícitas"
              : hasSupabaseConfig
                ? "Supabase configurado"
                : "Não configurado"
          }
          note="Produção nunca cai silenciosamente para dados fake."
        />
        <Setting
          icon={ShieldCheck}
          title="Privacidade"
          value="RLS + allowlist"
          note="Nenhuma página analítica deve ser pública."
        />
        <Setting
          icon={Network}
          title="Arquitetura"
          value="Multi-ecossistema"
          note="Seed → deployment → plataforma → tenant."
        />
        <Setting
          icon={Smartphone}
          title="Acesso"
          value="Web responsiva + PWA"
          note="Desktop e mobile usam o mesmo centro operacional."
        />
        <Setting
          icon={KeyRound}
          title="Ingest"
          value="HMAC por deployment"
          note="Chaves ficam no Worker, nunca no frontend."
        />
      </div>
      <section className="table-card">
        <div className="card-heading">
          <div>
            <h3>Configuração esperada</h3>
            <p>Somente configuração pública no frontend; credenciais ficam no backend.</p>
          </div>
        </div>
        <div className="code-panel">
          <code>VITE_SUPABASE_URL</code>
          <code>VITE_SUPABASE_ANON_KEY</code>
          <code>VITE_ESTUFA_DEMO_MODE=false</code>
          <code>Worker secrets: backend only</code>
        </div>
      </section>
    </>
  );
}
